function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 90,
  cy: 90,
  r: 88.5,
  stroke: "#7B7B7B",
  strokeWidth: 3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6 31.312V74H70.232V45.136L57.688 61.84L45.464 45.2V74H35.544V31.312H46.104L58.072 47.952L70.296 31.312H80.6Z",
  fill: "#2EBC2E"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M121.693 74.896C118.45 74.896 115.634 74.6613 113.245 74.192C110.855 73.7653 108.637 73.0187 106.589 71.952V62.096C108.509 63.632 110.685 64.8267 113.117 65.68C115.591 66.4907 118.002 66.896 120.349 66.896C124.359 66.896 126.365 65.3813 126.365 62.352C126.365 61.0293 125.725 60.0053 124.445 59.28C123.165 58.512 121.095 57.6587 118.237 56.72C116.914 56.2933 116.103 56.016 115.805 55.888C112.733 54.864 110.301 53.4773 108.509 51.728C106.759 49.9787 105.885 47.376 105.885 43.92C105.885 41.488 106.482 39.248 107.677 37.2C108.871 35.1093 110.706 33.4453 113.181 32.208C115.655 30.9707 118.706 30.352 122.333 30.352C124.85 30.352 127.005 30.5867 128.797 31.056C130.631 31.4827 132.573 32.1867 134.621 33.168V43.088C132.829 41.7227 130.909 40.592 128.861 39.696C126.813 38.8 124.743 38.352 122.653 38.352C120.775 38.352 119.261 38.736 118.109 39.504C116.999 40.2293 116.445 41.296 116.445 42.704C116.445 43.8133 116.786 44.7307 117.469 45.456C118.151 46.1387 118.983 46.672 119.965 47.056C120.989 47.44 122.61 47.9733 124.829 48.656C127.474 49.424 129.65 50.2773 131.357 51.216C133.063 52.1547 134.429 53.4133 135.453 54.992C136.477 56.5707 136.989 58.5973 136.989 61.072C136.989 63.6747 136.391 66.0213 135.197 68.112C134.002 70.2027 132.231 71.8667 129.885 73.104C127.581 74.2987 124.85 74.896 121.693 74.896Z",
  fill: "#FFA500"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.6 101.312V144H70.232V115.136L57.688 131.84L45.464 115.2V144H35.544V101.312H46.104L58.072 117.952L70.296 101.312H80.6Z",
  fill: "#1E90FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M107.357 101.312H117.725V118.592H133.405V101.312H143.709V144H133.405V127.04H117.725V144H107.357V101.312Z",
  fill: "#E95AE9"
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 92.5,
  y1: 15,
  x2: 92.5,
  y2: 165,
  stroke: "#7B7B7B",
  strokeWidth: 5
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 15,
  y1: 87.5,
  x2: 165,
  y2: 87.5,
  stroke: "#7B7B7B",
  strokeWidth: 5
});

const SvgMsmhCircleLogo = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMsmhCircleLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/MSMH_Circle_Logo.0d6178e3.svg";
export { ForwardRef as ReactComponent };